import { render, staticRenderFns } from "./ShoppingGuideProducts.vue?vue&type=template&id=6a9a2740&scoped=true&"
import script from "./ShoppingGuideProducts.vue?vue&type=script&lang=js&"
export * from "./ShoppingGuideProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9a2740",
  null
  
)

export default component.exports